const errorRoutes = [
  {
    path: '/error/404',
    name: '404',
    component: () => import('@/views/error/404')
  },
  {
    path: '*',
    redirect: '/error/404'
  }

]

export default errorRoutes
